export const MONITORING_TAB_QUERY_KEY = 'tab'

export const MONITORING_TABS = [
  'gas_fee',
  'rpc',
  'platform_wallet',
  'cache',
  'contracts',
  'webhook',
  'solana',
  'side_effect_jobs',
  'queue_quarantine',
  'testnet_faucet',
  'cooldown',
] as const

export type MonitoringTab = (typeof MONITORING_TABS)[number]

export const DEFAULT_MONITORING_TAB: MonitoringTab = 'gas_fee'

export const isMonitoringTab = (value: string | null): value is MonitoringTab =>
  value !== null && MONITORING_TABS.includes(value as MonitoringTab)

export const getMonitoringTabIndex = (tab: MonitoringTab): number =>
  MONITORING_TABS.indexOf(tab)

export const getMonitoringTabFromIndex = (index: number): MonitoringTab =>
  MONITORING_TABS[index] ?? DEFAULT_MONITORING_TAB

/**
 * URL values are authoritative when present. An unsupported URL value must not
 * fall through to a user's persisted tab, otherwise a broken link can appear
 * to open successfully on an unrelated panel.
 */
export const resolveMonitoringTab = (
  urlValue: string | null,
  storedIndex: number
): MonitoringTab => {
  if (urlValue !== null) {
    return isMonitoringTab(urlValue) ? urlValue : DEFAULT_MONITORING_TAB
  }

  return getMonitoringTabFromIndex(storedIndex)
}
